import { url } from "inspector";

export class Select2Helper {
    public static BindSelect2Input(selectElement: JQuery<HTMLElement>, dropdownParent: JQuery<HTMLElement> | undefined = undefined) {
        var defaultPlaceholder = selectElement.data('placeholder');
        var searchPlaceholder = selectElement.data('search-placeholder');
        var noResultsMessage = selectElement.data('no-results-message');
        var allowTags : boolean = selectElement.data('allow-tags');
        var allowMultiple : boolean = selectElement.data('multiple');
        var doCloseOnSelect : boolean = selectElement.data('close-on-select');
        var maxTagLength : number = selectElement.data('max-tag-length');
        var isInvalidClass : boolean = selectElement.hasClass('is-invalid');
        var normalSize : boolean = selectElement.data('normal-size');
        var smallSize : boolean = selectElement.data('small-size');
        var searchUrl : string = selectElement.data('search-url');
        var minSearchInput : number | undefined = selectElement.data('min-input-length');

        if(minSearchInput == undefined || minSearchInput.toString().length == 0) {
            minSearchInput = undefined;
        }
        
        if(maxTagLength == 0) {
            maxTagLength = 50;
        }

        if(selectElement.hasClass("select2-hidden-accessible")) {
            return;
        }

        var ajaxRequest : any = undefined;
        if(searchUrl != undefined && searchUrl.length > 0) {
            ajaxRequest = {
                url: searchUrl,
                dataType: 'json',
                data: function (params) {
                    var query = {
                        search: params.term,
                        page: params.page || 1
                    }

                    // Query parameters will be ?search=[term]&page=[page]
                    return query;
                }
            }
        }

        var modalParent = selectElement.closest('.modal');
        if(modalParent.length >= 1) {
            dropdownParent = modalParent;
        }

        selectElement.select2({
            theme: "bootstrap-5",
            placeholder : defaultPlaceholder ?? "",
            dropdownParent: dropdownParent,
            language: {
                noResults: () => {
                    return noResultsMessage ?? "No results found";
                }
            },
            multiple: allowMultiple,
            closeOnSelect: doCloseOnSelect,
            tags: allowTags,
            allowClear: allowMultiple,
            dropdownCssClass: allowMultiple ? 'select2--small' : '',
            minimumInputLength: minSearchInput,
            createTag: function (params) {
                // don't allow tags which are less than 3 charackter
                if (params.term.length > maxTagLength) {
                  // Return null to disable tag creation
                  return null;
                }
            
                return {
                  id: params.term,
                  text: params.term
                }
            },
            ajax: ajaxRequest

            
        });

        var searchPlaceholder = selectElement.data('search-placeholder');
    
        // if(isInvalidClass) {
        //     selectElement.addClass('is-invalid');
        // }

        var select2Id : string = selectElement.data('select2-id');
        select2Id = select2Id.replace('-data-', '-');

        var select = $(`#${select2Id}-container`).parent();
        if(isInvalidClass) {
            select.addClass('is-invalid');
        }        
        
        if(normalSize) {
            select.addClass('select2-normal-size');
        }

        if(smallSize) {
            select.addClass('select2-sm');
        }

        selectElement.on('select2:open', () => {
            var searchField = $(`input[aria-controls="${select2Id}-results"].select2-search__field`);
            $('.select2-search__field')[0].focus();
            searchField.prop('placeholder', searchPlaceholder);
        })

        
        var isClearClicked = false;
        var openCloseFixAfterClear = (e) => {
            if (isClearClicked) {
                e.preventDefault();
                isClearClicked = false;
            }
        }

        selectElement.on('select2:opening', (e) => {
            openCloseFixAfterClear(e);
        })
        selectElement.on('select2:closing', (e) => {
            openCloseFixAfterClear(e);
        })
        selectElement.on('select2:unselect', (e) => {
            isClearClicked = true;
        })
    }
}